export default __webpack_public_path__ + "static/home-renovation-f02aab013a54afe5ea7677ad67d31648.webp";